import { computed } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

/**
 * Apartments Composable
 * Bietet Zugriff auf Apartment-Daten und -Funktionen
 */
export function useApartments() {
  const apiStore = useApiStore()

  return {
    // Data
    apartments: computed(() => apiStore.apartments),
    
    // States
    loading: computed(() => apiStore.apartmentsLoading),
    error: computed(() => apiStore.apartmentsError),
    hasApartments: computed(() => apiStore.hasApartments),
    
    // Getters
    getBySlug: (slug) => apiStore.getApartmentBySlug(slug),
    getById: (id) => apiStore.getApartmentById(id),
    
    // Actions
    load: () => apiStore.loadApartments(),
    
    // Utility
    findBySlug: computed(() => (slug) => apiStore.getApartmentBySlug(slug)),
    findById: computed(() => (id) => apiStore.getApartmentById(id))
  }
}